const map = {
	"./guild.json": 75341,
	"./items.json": 95374,
	"./lendingMessage.json": 89052,
	"./notificationMessage.json": 74300,
	"./profile.json": 55163,
	"./specialRace.json": 92048,
	"i18n/en/guild.json": 75341,
	"i18n/en/items.json": 95374,
	"i18n/en/lendingMessage.json": 89052,
	"i18n/en/notificationMessage.json": 74300,
	"i18n/en/profile.json": 55163,
	"i18n/en/specialRace.json": 92048
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51232;